import neue from '../../data/neue';

const state = {
    neue_bet: []
};

const mutations = {
    'SET_NEUE'(state, neue_bet) {
        state.neue_bet = neue_bet;
    }
};

const actions = {
    initNeue: ({commit}) => {
        commit('SET_NEUE', neue)
    }
};
const getters = {
    Neue: state => {
        return state.neue_bet;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Neue.js